import { Skeleton, Flex, Heading, Spacer } from '@chakra-ui/react';
import React from 'react';

import { AssignmentEditStrategyContainer } from './AssignmentEditStrategyContainer';
import { useLatestAssignmentPipelineRunMetadataForLpGroupingContext } from 'packages/loanProduct/hooks/LatestAssignmentPipelineRunMetadataForLpGroupingProvider';
import { useLoanProductCreditFacilityGroupContext } from 'packages/loanProduct/hooks/LoanProductCreditFacilityGroupingProvider';
import { usePreviewGenerationStatus } from 'packages/loanProduct/hooks/useGetPreviewGenerationStatus';
import { CheckLatestPipelineRunStatus } from 'packages/loanProduct/ui/v2/CheckLatestPipelineRunStatus';

export const AssignmentApplyStrategyContainer = ({
  organizationId,
}: {
  organizationId: string;
}) => {
  const { lpToCfEntityGrouping } = useLoanProductCreditFacilityGroupContext();
  const {
    metadata,
  } = useLatestAssignmentPipelineRunMetadataForLpGroupingContext();
  const { isCompleted } = usePreviewGenerationStatus({
    loanProductIds:
      lpToCfEntityGrouping?.loanProducts.map(({ id }) => id) ?? [],
    organizationId,
    reportingDate: metadata?.reportingDate,
    fileVersion: metadata?.fileVersion,
  });

  if (!metadata) {
    return <Skeleton w="100%" h="100%" />;
  }

  return (
    <CheckLatestPipelineRunStatus>
      {({ StatusAlert }) => {
        if (metadata === null || isCompleted === null) {
          return <Skeleton h="25%" />;
        }
        if (
          metadata.status !== 'success' ||
          (metadata.status === 'success' && !isCompleted)
        ) {
          return (
            <>
              <Flex justify="space-between" mb="24px">
                <Heading as="h2">Apply Strategy</Heading>
                <Spacer />
              </Flex>
              <StatusAlert
                status={
                  !isCompleted ? 'inProgress' : metadata?.status || 'inProgress'
                }
              />
            </>
          );
        }
        return (
          <AssignmentEditStrategyContainer
            organizationId={organizationId}
            readOnly
          />
        );
      }}
    </CheckLatestPipelineRunStatus>
  );
};
